<template>
    <div class="profile">
        <h1 class="ui header">Your Profile</h1>
        <div id="purchasedOffsets" v-if="userDetails !== null && totalContributionCount > 0">
            <div id="userTotals">
                <div id="userCo2" class="calculated-icon">
                    <i class="fas fa-cloud"></i>
                    <div class="co2-overlay">CO2</div>
                    <div class="icon-caption"><span class="calc-value">{{roundToDecimal(lbsCo2(userDetails.mt), 1)}}</span> LBS of carbon<br/> offsets purchased</div>
                </div>
                <div id="userTrees" class="calculated-icon">
                    <i class="fas fa-tree"></i>
                    <div class="icon-caption"><span class="calc-value">{{roundToDecimal(userDetails.trees, 1)}}</span> Trees</div>
                </div>
            </div>
            <h2 id="contribHead">Your Contributions</h2>
            <div id="viewSelectWrap">
                <label id="viewSelectLabel" for="viewSelect">View: </label>
                <select id="viewSelect" v-model="view">
                    <option v-for="(value, key) in view_list" :value="key">{{value}}</option>
                </select>
            </div>
            <table id="contributions">
                <tr class="contribution" v-for="contribution in contributionList">
                    <td class="contrib-amount">${{contribution.amount}}</td>
                    <td class="contrib-details">
                        <div class="event-name" v-if="contribution.type === 'travel_carbon_calculator'"><router-link :to="'/event/' + contribution.event_id">{{contribution.event}}</router-link></div>
                        <div class="event-name" v-if="contribution.type === 'general_living_calculator'">Lifestyle Emissions Contribution</div>
                        <div class="event-name" v-if="contribution.type === 'direct_contributions'">Direct Contribution</div>
                        <div class="sub-details">
                            <div class="contrib-sponsor">{{contribution.sponsor ? 'Sponsored by: ' + contribution.sponsor.name : ''}}</div>
                            <div class="contrib-date">{{parseTimestamp(contribution.when)}}</div>
                        </div>
                    </td>
                </tr>
            </table>
        </div>
        <div id="noPurchasedOffsets" v-else>
            You haven't contributed to any carbon offsets! <router-link to="/">Contribute now.</router-link>
        </div>
        <div id="loadingUser" v-if="!userDetails">Loading...</div>
    </div>
</template>

<script>
    import axios from "axios";
    import formatting from "../mixins/formatting";

    export default {
        name: 'Profile',
        mixins: [formatting],
        data() {
            return {
                claims: [],
                userDetails: null,
                view: "all",
                // view_list: ["all"],
                view_list: {
                    all: "All",
                    travel_carbon_calculator: "Travel Carbon Contributions",
                    general_living_calculator: "Lifestyle Emissions Contributions",
                    direct_contributions: "Direct Carbon Contributions"

                }
            };
        },
        computed: {
            contributionList() {
                console.log(this.userDetails);
                if (this.userDetails != null) {
                    let entries = [];
                    if (this.view === "all") {
                        for (let list in this.userDetails.contributions) {
                            if (this.userDetails.contributions.hasOwnProperty(list)) {
                                entries = entries.concat(this.userDetails.contributions[list]);
                            }
                        }
                    } else {
                        entries = this.userDetails.contributions[this.view];
                    }
                    entries.sort((a, b) => {
                        return a.when < b.when ? 1 : -1;
                    });
                    return entries;
                }
            },
            totalContributionCount() {
                let total = 0;
                Object.keys(this.userDetails.contributions).forEach(key => {
                    if (this.userDetails.contributions.hasOwnProperty(key)) {
                        total += this.userDetails.contributions[key].length;
                    }
                });
                return total;
            }
        },
        async created() {
            // console.log(await this.$auth.getUser());
            this.claims = Object.entries(await this.$auth.getUser()).map(entry => ({
                claim: entry[0],
                value: entry[1]
            }));
            this.userDetails = await axios.get(
                this.$store.getters["server"] + "/user-details",
                {
                    params: {
                        // dummy: 10,
                        id: await this.$store.getters["user/getItem"]("userId")
                    }
                }).then((response) => { return response.data.object; });
            // console.log(this.userDetails);
        },
        methods: {
            parseTimestamp(when) {
                let date = new Date(Math.round(when * 1000));
                return date.toLocaleDateString('en-US', {day: 'numeric', month: 'short', year: 'numeric'});
            },
            lbsCo2(mt) {
                return mt * 2204.623;
            },
            prepareName(key) {
                return key.split("_").map((item) => {
                    return item[0].toUpperCase() + item.slice(1);
                }).join(" ");
            }
        }
    };
</script>

<style scoped lang="less">
    @import (reference) "../assets/variables";

    #userTotals{
        display: flex;
        justify-content: space-around;
    }
    .icon-caption {
        font-size: 1rem;
        text-transform: uppercase;
        letter-spacing: 0.05em;
        color: @light-gray;
    }

    .co2-overlay {
        font-size: 1.4rem;
        color: white;
        position: absolute;
        width: 100%;
        top: 1.25em;
        text-align: center;
        font-weight: 700;
    }
    .calculated-icon {
        text-align: center;
        font-size: 4rem;
        position: relative;
        color: @orange;
    }

    #contribHead{
        margin: 1.75rem 0 1.25rem;
    }
    #viewSelectWrap{
        display: flex;
        align-items: center;
    }
    #viewSelectLabel{
        font-size: 1.15em;
        margin-right: 0.5rem;
    }
    #viewSelect{
        border-bottom: 2px solid @lightest-gray;
    }
    #contributions{
        //list-style: none;
        border-collapse: collapse;
        table-layout: auto;
        width: 100%;
        padding: 0;
        margin: 0;
    }
    .contribution{
        padding: 1rem 0;
        border-bottom: 2px solid @lightest-gray;
        &:last-child{
            border: 0;
        }
    }
    .contrib-amount{
        font-size: 2.25rem;
        font-family: Lora, serif;
        /*width: 2.5em;*/
        margin: 0 0.5em 1rem 0;
        padding: 0.75rem 1rem 0.75rem 0;
        text-align: right;
        line-height: 1;
    }
    .contrib-details{
        color: @text-color;
        text-align: left;
        width: 100%;
    }
    .sub-details{
        font-size: 0.8em;
        display: flex;
        justify-content: space-between;
    }
</style>



// WEBPACK FOOTER //
// src/components/Profile.vue